<template>
	<div
		tabindex="0"
		class="fixed w-full inset-0 z-50 overflow-hidden flex justify-center items-center"
		style="background: rgba(255,255,255,.7);"
		v-show="isLoading"
		:aria-busy="isLoading"
		aria-label="Laden"
	>
		<svg
			viewBox="0 0 38 38"
			xmlns="http://www.w3.org/2000/svg"
			width="90"
			height="90"
			stroke="#000"
		>
			<g fill="none" fill-rule="evenodd">
				<g transform="translate(1 1)" stroke-width="2">
					<circle stroke-opacity=".25" cx="18" cy="18" r="18" />
					<path d="M36 18c0-9.94-8.06-18-18-18">
						<animateTransform
							attributeName="transform"
							type="rotate"
							from="0 18 18"
							to="360 18 18"
							dur="0.8s"
							repeatCount="indefinite"
						/>
					</path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
	export default {
		props: ["isLoading"],
	};
</script>
